import { Box, styled } from "@mui/material"
import core from "../assets/jss/core"

const DefaultCardContent = styled(Box)({
    padding: 16,
    paddingBottom: 16,
})

export default DefaultCardContent